import React, { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, useMap, useMapEvents } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

const NEVERS = [46.9909, 3.1628];

const ClickToPlace = ({ onPick }) => {
  useMapEvents({
    click(e) {
      onPick(e.latlng.lat, e.latlng.lng);
    },
  });
  return null;
};

const InvalidateSize = () => {
  const map = useMap();
  useEffect(() => {
    const t = window.setTimeout(() => map.invalidateSize(), 80);
    return () => window.clearTimeout(t);
  }, [map]);
  return null;
};

const KkpDistribPointMapPicker = ({ latitude, longitude, onChange }) => {
  const hasPoint = latitude != null && longitude != null
    && !Number.isNaN(Number(latitude))
    && !Number.isNaN(Number(longitude));
  const lat = hasPoint ? Number(latitude) : NEVERS[0];
  const lng = hasPoint ? Number(longitude) : NEVERS[1];

  return (
    <div className="kkp-distrib-map-picker">
      <MapContainer
        center={[lat, lng]}
        zoom={hasPoint ? 16 : 12}
        style={{ height: '100%', width: '100%' }}
        scrollWheelZoom
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <InvalidateSize />
        <ClickToPlace onPick={(nextLat, nextLng) => onChange(nextLat, nextLng)} />
        {hasPoint ? (
          <Marker
            position={[lat, lng]}
            draggable
            eventHandlers={{
              dragend: (event) => {
                const next = event.target.getLatLng();
                onChange(next.lat, next.lng);
              },
            }}
          />
        ) : null}
      </MapContainer>
    </div>
  );
};

export default KkpDistribPointMapPicker;
